import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	InputSignal,
	OnDestroy,
	OnInit,
	Signal,
	signal,
	WritableSignal,
	inject,
} from '@angular/core'

import { AssetClassEnum } from '@modules/positions-module/enums/asset-class.enum'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { InfoOptionsComponent } from './info-options/info-options.component'
import { InfoStocksComponent } from './info-stocks/info-stocks.component'
import { Subject, takeUntil } from 'rxjs'
import { LiveTickerInterface } from '@modules/stocks-module/live-ticker/interfaces/live-ticker.interface'
import { LiveTickerService } from '@modules/stocks-module/live-ticker/services/live-ticker.service'
import { AssetTypesComponent } from '@shared/components/common/asset-type/asset-type.component'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'
import { TranslatePipe } from '@ngx-translate/core'
import { InfoStocksTabEnum } from '@shared/components/trading/info/core/enums/info-stocks-tab.enum'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'

@UseLocales({ ru, en })
@Component({
	selector: 'app-info',
	templateUrl: './info.component.html',
	styleUrl: './info.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [InfoStocksComponent, InfoOptionsComponent, AssetTypesComponent, ButtonComponent, TranslatePipe],
})
export class InfoComponent implements OnInit, OnDestroy {
	protected readonly object: ObjectConstructor = Object
	protected readonly assetClassEnum: typeof AssetClassEnum = AssetClassEnum
	protected readonly infoStocksTabEnum: typeof InfoStocksTabEnum = InfoStocksTabEnum
	protected readonly tabList: InfoStocksTabEnum[] = this.object.values(this.infoStocksTabEnum)

	public widget: InputSignal<WidgetInterface | null> = input<WidgetInterface | null>(null)

	private _destroy$: Subject<void> = new Subject<void>()

	private readonly _liveTickerService: LiveTickerService = inject<LiveTickerService>(LiveTickerService)

	protected assetClass: Signal<AssetClassEnum> = computed(
		(): AssetClassEnum => this.widget()?.assetClass ?? this.assetClassEnum.US_EQUITY,
	)

	protected liveTicker: WritableSignal<LiveTickerInterface | null> = signal<LiveTickerInterface | null>(null)
	protected activeTab: WritableSignal<InfoStocksTabEnum | undefined> = signal<InfoStocksTabEnum | undefined>(
		this.tabList[0],
	)
	private _listenLiveTicker(): void {
		this._liveTickerService.liveTicker$
			.pipe(takeUntil(this._destroy$))
			.subscribe((liveTicker: LiveTickerInterface | null): void => {
				this.liveTicker.set(liveTicker)
			})
	}

	protected setTab(tab: InfoStocksTabEnum): void {
		this.activeTab.set(tab)
	}

	ngOnInit(): void {
		this._listenLiveTicker()
	}

	ngOnDestroy(): void {
		this._destroy$.next()
		this._destroy$.complete()
	}
}
